exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cnt-item.disabled{\r\n    opacity: 0.5;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/slick-grid/components/column-list.component/column-list.component.css
// module id = ./src/app/slick-grid/components/column-list.component/column-list.component.css
// module chunks = main